import { FC } from "react";
import { DialogModal } from "@/components/Modal";
import { processTextWithIcons } from "./InfoTextSection";
import { getParagraphs } from "./getParagraphs";

type NotificationModalProps = {
  open: boolean;
  onClose: () => void;
  header?: string;
  description?: string;
};

const NotificationModal: FC<NotificationModalProps> = ({
  open,
  onClose,
  header,
  description,
}) => (
  <DialogModal open={open} onClose={onClose} panelClassName="!max-w-152">
    <div className="relative">
      {header && (
        <p className="text-subhead-m text-swdc-black-600 mb-6 font-bold">
          {header}
        </p>
      )}
      <div className="flex items-center justify-center">
        <div
          className="text-swdc-silver-200 h-0.5 w-124 border-2 border-t"
          aria-hidden="true"
        />
      </div>
      {description && (
        <div className="text-body-m text-swdc-gray-400 mt-6">
          {getParagraphs(description).map((text, paragraphIndex) => (
            <p key={`notification-paragraph-${paragraphIndex}`}>
              {processTextWithIcons(text)}
            </p>
          ))}
        </div>
      )}
    </div>
  </DialogModal>
);

export default NotificationModal;
